import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UserProfile } from 'src/app/core/models/user/user-profile.model';
import { UserImageProviderService } from 'src/app/shared/common-features/services/option-image-providers/user-image-provider.service';

@Component({
    selector: 'app-sidenav-content-user-info',
    templateUrl: './sidenav-content-user-info.component.html',
    styleUrls: ['./sidenav-content-user-info.component.scss'],
    standalone: false
})
export class SidenavContentUserInfoComponent {

  @Input() user: UserProfile | undefined | null

  constructor(readonly userImageProviderService: UserImageProviderService) {
  }

}
